import styled from 'styled-components';

export const MeasurementsPaneStyled = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  flex-flow: column;

  > .ToolsArea {
    width: 100%;
  }
`;

export const ImageInfoStyled = styled.div`
  display: grid;
  align-items: center;
  grid-template-columns: 150px 120px auto;
  padding: 0 5px;
  grid-gap: 5px;

    > .ScaleSlider {
      grid-column-start: 2;
      grid-column-end: 4;
    }

    > .Length {
      text-align: right;
    }

    > input {
      height: 25px;
      padding: 0px 2px 0px 2px;
      min-width: 50px;
    }
`;